import i18next from 'i18next'

import { SelectOption } from 'components/Select'
import { DomainBidderPriority } from 'features/globalSetup/types/bidderPriority'
import {
  UnfilledRecoveryPrebidBehaviour,
  unfilledRecoveryPrebidBehaviours,
} from 'features/inventory/types/unfilledRecoveryPrebidBehaviour'
import { LazyLoad, lazyLoadValues } from 'types/lazyLoad'

export const domainBidderPriorityOptions = (
  priorities: DomainBidderPriority[],
): SelectOption<DomainBidderPriority>[] =>
  priorities.map(
    (priority: DomainBidderPriority): SelectOption<DomainBidderPriority> => ({
      label: i18next.t(`features/globalSetup:prebid.bidders.priorityOptions.${priority}`),
      value: priority,
    }),
  )

export const lazyLoadTypeOptions = (): SelectOption<LazyLoad>[] =>
  lazyLoadValues.map(
    (option: LazyLoad): SelectOption<LazyLoad> => ({
      label: i18next.t(
        `features/domain:form.viewabilityTools.basicSettings.lazyLoadingEnabled.options.lazyLoadType.${option}`,
      ),
      value: option,
    }),
  )

export const prebidBehavioursOptions = (): SelectOption<UnfilledRecoveryPrebidBehaviour>[] =>
  unfilledRecoveryPrebidBehaviours.map(
    (
      prebidBehaviour: UnfilledRecoveryPrebidBehaviour,
    ): SelectOption<UnfilledRecoveryPrebidBehaviour> => ({
      label: i18next.t(
        `features/domain:form.unfilledRecovery.prebidSettings.prebidBehaviourType.values.${prebidBehaviour}.content`,
      ),
      value: prebidBehaviour,
    }),
  )
